<template lang="pug">
	
	.youth-intro

		section-intro(:img="babyImg" :title="translate('youth.title')" :onEnter="onEnter" :onLeave="onLeave")
		//- youth-presentation

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '~utils/scroller.js'
	import Ticker from '~utils/ticker.js'	
	import * as PIXI from 'pixi.js'
	import SectionIntro from '~components/section-intro.vue'
	import Scrollable from '~abstracts/scrollable'
	import YouthPresentation from './youth-presentation.vue'

	import YouthBaby from 'assets/images/youth-baby.jpg'


  	@Component({
		name: 'YouthIntro',
		components: { SectionIntro,YouthPresentation },
		data: function () {
			return {
				babyImg: YouthBaby 
			}
		}
	})

	class YouthIntro extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
		
		}

		onEnter () {
			this.$events.emit('scroll.out')
		}

		onLeave () {
			this.$events.emit('scroll.in')
		}

		_resize () {
			super._resize()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default YouthIntro

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.youth-intro
		width 100%
		position relative
	
</style>


// WEBPACK FOOTER //
// youth-intro.vue?04ee5b84